import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AdTypes } from '@bingads-webui-campaign-react/campaign-onboarding-v2';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import appConfig from '@bingads-webui-component-legacy/config/index';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
import { Layout } from '@bingads-webui-react/wizard';
import { isDealCampaign, isCTVCampaign, getVideoDeal } from '@bingads-webui-campaign-react/xandr-video-campaign-shared-components';
import { withScope } from '@bingads-webui-react/scope-service';
import { ErrorBar } from '@bingads-webui-fluent-component/wizard-ui-library';

import { AD_TYPES_TO_FLOWS } from '../step-constants';
import { DisplayPlusWizard } from './wizard';
import { DisplayPlusStepFooter } from '../footers';
import { StepList } from '../step-list';

const getDisplayPlusCampaignType = () => {
  let displayPlusCampaignType = appConfig.get('DisplayPlusCampaignType');
  if (!displayPlusCampaignType) {
    if (localStorage && localStorage.supportsStorage()) {
      displayPlusCampaignType = localStorage.get('DisplayPlusCampaignType');
      displayPlusCampaignType = displayPlusCampaignType && displayPlusCampaignType.type;
      appConfig.set('DisplayPlusCampaignType', displayPlusCampaignType);
    }

    if (!displayPlusCampaignType) {
      if (isDealCampaign()) {
        displayPlusCampaignType = AdTypes.Netflix;
      } else if (isCTVCampaign()) {
        displayPlusCampaignType = AdTypes.AudienceVideo;
      }
    }
  }

  return displayPlusCampaignType;
};

const DisplayPlusCampaignWizardInternal = ({
  siteMap, perfMarker, scope, adsType, loadClipchampPlayer,
}) => {
  const routeToNavigateToWhenDone = getRoutePathById(siteMap, 'campaigns');

  const wizardType = getDisplayPlusCampaignType() || AdTypes.Native;
  const videoDeal = getVideoDeal();

  const flowType = AD_TYPES_TO_FLOWS[wizardType];

  useEffect(() => {
    if (isDealCampaign()) {
      if (!videoDeal) {
        // return to objective page if user navigates to this page directly
        scope.save('/campaign/vnext/createcampaign/objective');
      }
    }
  }, [scope, videoDeal]);

  const lifetimeBudgetFlowData = {
    isBudgetTypeEditable: true,
    isDateManagementEditable: true,
  };

  return (
    <DisplayPlusWizard
      adsType={adsType}
      wizardType={wizardType}
      flowType={flowType}
      routeToNavigateToWhenDone={routeToNavigateToWhenDone}
      perfMarker={perfMarker}
      loadClipchampPlayer={loadClipchampPlayer}
      initialWizardData={{
        videoDeal,
        lifetimeBudgetFlowData,
      }}
    >
      <Layout type="StepList" component={StepList} />
      <Layout type="ErrorBar" component={ErrorBar} />
      <Layout
        type="Footer"
        component={DisplayPlusStepFooter}
        nextButtonText={_TL_('Save & go to next step')}
      />
    </DisplayPlusWizard>
  );
};

DisplayPlusCampaignWizardInternal.propTypes = {
  siteMap: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  adsType: PropTypes.string,
};

export const DisplayPlusCampaignWizard = withSiteMap(withScope(DisplayPlusCampaignWizardInternal));
